import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivate,
  CanActivateChild,
} from "@angular/router";
import { AuthService } from "./auth.service";
import { map } from "rxjs/operators";
import { AuthModule } from "./auth.module";
import { UserInfoConfigurationService } from '../configuration/user-info/user-info-configuration.service';
import { UserInfoStorageService } from '../user-info/user-info-storage.service';
import { UserInfoService } from '../user-info/user-info.service';

@Injectable({
  providedIn: AuthModule,
})
export class AuthGuard implements CanActivate, CanActivateChild {

  get userInfoEnabled() {
    return this.userInfoConfiguration.enabled;
  }

  get userInfoConfiguration() {
    return this.userInfoConfigurationService.configuration;
  }

  get userInfo() {
    return this.userInfoStorageService.userInfo;
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private userInfoConfigurationService: UserInfoConfigurationService,
    private userInfoStorageService: UserInfoStorageService,
    private userInfoService: UserInfoService
  ) {}

  canActivateChild(childRoute, state) {
    return this.canActivate(childRoute, state);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.loadToken()) {
        if (this.userInfoEnabled) {
          if (this.userInfo) {
            return true;
          } else {
            return this.getUserInfo().pipe(
              map(() => {
                return true;
              })
            );
          }
        } else {
          return true;
        }
    } else {
      return this.parseUrl("/login/success");
    }
  }

  loadToken() {
    return this.authService.loadToken();
  }

  getUserInfo() {
    return this.userInfoService.getUserInfo();
  }

  parseUrl(url) {
    return this.router.parseUrl(url);
  }
}
